// @ts-nocheck
/* eslint-disable */
export const appPlus16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#plus-16_svg__clip0_10334_89196)"><circle cx="7.9998" cy="8.00005" r="6.7" stroke="currentColor"/><path d="M8.22852 4.11426V12.3428" stroke="currentColor"/><path d="M12.3447 8.22632L4.11616 8.22632" stroke="currentColor"/></g><defs><clipPath id="plus-16_svg__clip0_10334_89196"><rect width="16" height="16" rx="8"/></clipPath></defs></svg>`,
    name: 'plus-16' as const
};